export default __webpack_public_path__ + "static/media/Brew of Vigorous Acumen.ac2b0473.jpg";